<template>
  <element>
    <nav-breadcrumb :menu="[{label: '角色权限'},{label: '配置菜单'}]"/>
    <div class="bg-purple of">
      <panel title="角色信息">
        <el-form :inline="true" :model="roleMenu" label-width="100px">
          <el-form-item label="角色名称：">
            <el-input v-model="roleMenu.r__roleName"/>
          </el-form-item>
        </el-form>
      </panel>
      <panel title="配置角色菜单">
        <div class="qxedit" v-for="(item, idx) in roleMenu.r__menus" :key="idx">
          <div class="qxeditone">
            <p>
              <el-checkbox v-model="roleMenuIds" :label="item.id" border>{{item.text}}</el-checkbox>
            </p>
          </div>
          <ul class="qxedittwo">
            <li v-for="(item2, idx2) in item.nodes" :key="idx2">
              <p>
                <el-checkbox v-model="roleMenuIds" :label="item2.id" border>{{item2.text}}</el-checkbox>
              </p>
              <ul class="qxeditthree">
                <li>
                  <el-checkbox v-model="roleMenuIds" :label="item3.id" border v-for="(item3, idx3) in item2.nodes"
                               :key="idx3">{{item3.text}}
                  </el-checkbox>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </panel>
    </div>
    <el-row>
      <el-button type="primary" @click="handleSave">保存</el-button>
      <el-button @click="$router.go(-1)">返回</el-button>
    </el-row>
  </element>
</template>

<script>
  import xhr from '../../../utils/xhr.js'

  export default {
    data: function () {
      return {
        roleMenu: {},
        roleMenuIds: [],
        r__roleName: ''
      }
    },
    watch: {
      roleId: function (val) {
        this.getRoleMenu()
      },
      // roleMenu: function (val) {
      //   this.getRoleMenuIds(val.r__menus)
      //
      // },
      roleMenuIds: val => {
        console.log(val)
      }
    },
    mounted: function () {
      this.getRoleMenu()
    },
    computed: {
      roleId() {
        return this.$route.query.roleId || ''
      },
      roleType() {
        return this.$route.query.roleType || ''
      }
    },
    methods: {
      getRoleMenuIds: function (val) {
        val.map(item => {
          if (item.mapped === true) this.roleMenuIds.push(item.id)

          if (typeof item.nodes === 'object') {
            this.getRoleMenuIds(item.nodes)
          }
        })
      },
      //查询角色拥有的菜单
      getRoleMenu: function () {
        xhr.getRoleMenu({
          'r.roleId': this.roleId
        }, res => {
          this.roleMenu = res.data.data
          this.roleMenu.r__menus = JSON.parse(this.roleMenu.r__menus)
          this.r__roleName = this.roleMenu.r__roleName

          this.getRoleMenuIds(this.roleMenu.r__menus)
        })
      },
      //查询所有已启用的菜单
      getMenuSelector: function () {
        let that = this
        xhr.getMenuSelector({
          'm.menuType': this.roleType
        }, res => {
          that.menuSelector = res.data.data
          that.menuSelector.m__menus = JSON.parse(that.menuSelector.m__menus)
        })
      },
      //保存角色菜单
      handleSave: function () {
        let that = this
        delete(this.roleMenu.r__menus)
        this.roleMenu.menus = this.roleMenuIds.join(',')
        xhr.updateRoleMenu(this.roleMenu, res => {
          that.getRoleMenuIds()
        })
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/lender/setting/ConfigRoleEdit.vue